export default {
    loading: {
        module: true
    },
    params: {
        seller_type: "1",
        year_month_from: '',
        year_month_up: '',
        type_query: "1",
        lines: [],
    },
    params_cotact:{
        is_customer: false,
        is_provider: false,
        is_employee: false,
        filter_customer: [],
        filter_provider: [],
        filter_employee: [],
        paginate: true,
        page: 1,
        perPage: 50,
        query: '',
        sortBy: 'id',
        sort: 'ASC',
    },
    accounts_from: [],
    contacts:[],
    lines :[],
    reporte_comisiones:[],
    reporte_comisiones_descuentos:[],
    reporte_comisiones_pagos:[],
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    }
}



// WEBPACK FOOTER //
// ./src/modules/report-commisions/state.js